import { render } from "./A01MessageListPanel.vue?vue&type=template&id=25975f9e&scoped=true&ts=true"
import script from "./A01MessageListPanel.vue?vue&type=script&lang=ts"
export * from "./A01MessageListPanel.vue?vue&type=script&lang=ts"

import "./A01MessageListPanel.vue?vue&type=style&index=0&id=25975f9e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25975f9e"]])

export default __exports__